import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d12be72")

_pushScopeId("data-v-2d12be72")
const _hoisted_1 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_2 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon kn-flex" }, null, -1)
const _hoisted_7 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon kn-flex" }, null, -1)
const _hoisted_9 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil edit-icon kn-flex" }, null, -1)
const _hoisted_11 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_KpiDocumentDesignerKpiSelectDialog = _resolveComponent("KpiDocumentDesignerKpiSelectDialog")
  const _component_Card = _resolveComponent("Card")

  return (_ctx.data)
    ? (_openBlock(), _createBlock(_component_Card, {
        key: 0,
        class: "p-m-2"
      }, {
        header: _withId(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.kpiList')), 1)
            ]),
            _: 1
          })
        ]),
        content: _withId(() => [
          _createVNode("div", null, [
            _createVNode(_component_DataTable, {
              value: _ctx.data.kpi,
              class: "p-datatable-sm kn-table",
              dataKey: "name",
              filters: _ctx.filters,
              "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
              globalFilterFields: _ctx.KpiDocumentDesignerKpiListCardDescriptor.globalFilterFields,
              responsiveLayout: "stack",
              breakpoint: "960px",
              scrollable: true,
              "scroll-height": "60vh"
            }, {
              header: _withId(() => [
                _createVNode("div", _hoisted_1, [
                  _createVNode("span", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      modelValue: _ctx.filters['global'].value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                      type: "text",
                      placeholder: _ctx.$t('common.search'),
                      "data-test": "filterInput"
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _createVNode(_component_Button, {
                    id: "kpi-edit-add-kpi-associations-button",
                    class: "kn-button kn-button--primary",
                    label: _ctx.$t('kpi.kpiScheduler.addKpiAssociation'),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addKpiAssociationVisible = true))
                  }, null, 8, ["label"])
                ])
              ]),
              empty: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.KpiDocumentDesignerKpiListCardDescriptor.columns, (col) => {
                  return (_openBlock(), _createBlock(_component_Column, {
                    class: "kn-truncated",
                    field: col.field,
                    header: _ctx.$t(col.header),
                    key: col.field,
                    style: col.style,
                    sortable: true
                  }, null, 8, ["field", "header", "style"]))
                }), 128)),
                (_ctx.showSaveAsColumn)
                  ? (_openBlock(), _createBlock(_component_Column, {
                      field: "vieweas",
                      header: _ctx.$t('kpi.kpiDocumentDesigner.viewAs'),
                      key: "vieweas",
                      sortable: true,
                      style: _ctx.KpiDocumentDesignerKpiListCardDescriptor.columnStyle
                    }, {
                      body: _withId((slotProps) => [
                        _createVNode(_component_Dropdown, {
                          class: "kpi-edit-kpi-list-card-dropdown",
                          modelValue: slotProps.data[slotProps.column.props.field],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                          options: _ctx.KpiDocumentDesignerKpiListCardDescriptor.viewAsOptions,
                          optionValue: "value",
                          placeholder: _ctx.$t('kpi.kpiDocumentDesigner.viewAsPlaceholder')
                        }, {
                          value: _withId((slotProps) => [
                            (slotProps.value)
                              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                                  _createVNode("span", null, _toDisplayString(slotProps.value === 'speedometer' ? _ctx.$t('kpi.kpiDocumentDesigner.speedometer') : _ctx.$t('kpi.kpiDocumentDesigner.kpiCard')), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          option: _withId((slotProps) => [
                            _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["header", "style"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Column, {
                  field: "rangeMinValue",
                  header: _ctx.$t('kpi.kpiDocumentDesigner.rangeMinValue'),
                  key: "rangeMinValue",
                  sortable: true,
                  style: _ctx.KpiDocumentDesignerKpiListCardDescriptor.columnStyle
                }, {
                  body: _withId((slotProps) => [
                    _createVNode("div", _hoisted_5, [
                      _createVNode(_component_InputText, {
                        class: ["kn-material-input p-mr-2 kn-flex", { 'p-invalid': !slotProps.data[slotProps.column.props.field] }],
                        type: "number",
                        modelValue: slotProps.data[slotProps.column.props.field],
                        "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                      _hoisted_6
                    ])
                  ]),
                  _: 1
                }, 8, ["header", "style"]),
                _createVNode(_component_Column, {
                  field: "rangeMaxValue",
                  header: _ctx.$t('kpi.kpiDocumentDesigner.rangeMaxValue'),
                  key: "rangeMaxValue",
                  sortable: true,
                  style: _ctx.KpiDocumentDesignerKpiListCardDescriptor.columnStyle
                }, {
                  body: _withId((slotProps) => [
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_InputText, {
                        class: ["kn-material-input p-mr-2 kn-flex", { 'p-invalid': !slotProps.data[slotProps.column.props.field] }],
                        type: "number",
                        modelValue: slotProps.data[slotProps.column.props.field],
                        "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                      _hoisted_8
                    ])
                  ]),
                  _: 1
                }, 8, ["header", "style"]),
                _createVNode(_component_Column, {
                  field: "prefixSuffixValue",
                  header: _ctx.$t('kpi.kpiDocumentDesigner.prefixSuffixLabel'),
                  key: "prefixSuffixValue",
                  sortable: true,
                  style: _ctx.KpiDocumentDesignerKpiListCardDescriptor.columnStyle
                }, {
                  body: _withId((slotProps) => [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_InputText, {
                        class: "kn-material-input p-mr-2 kn-flex",
                        modelValue: slotProps.data[slotProps.column.props.field],
                        "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                        maxLength: "3"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _hoisted_10
                    ])
                  ]),
                  _: 1
                }, 8, ["header", "style"]),
                _createVNode(_component_Column, {
                  field: "isSuffix",
                  header: _ctx.$t('kpi.kpiDocumentDesigner.showLabelAs'),
                  key: "isSuffix",
                  sortable: true,
                  style: _ctx.KpiDocumentDesignerKpiListCardDescriptor.columnStyle
                }, {
                  body: _withId((slotProps) => [
                    _createVNode(_component_Dropdown, {
                      modelValue: slotProps.data[slotProps.column.props.field],
                      "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                      options: _ctx.KpiDocumentDesignerKpiListCardDescriptor.prefixSuffixOptions,
                      optionValue: "value"
                    }, {
                      value: _withId((slotProps) => [
                        (slotProps.value)
                          ? (_openBlock(), _createBlock("div", _hoisted_11, [
                              _createVNode("span", null, _toDisplayString(slotProps.value === 'true' ? _ctx.$t('kpi.kpiDocumentDesigner.suffix') : _ctx.$t('kpi.kpiDocumentDesigner.prefix')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      option: _withId((slotProps) => [
                        _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["header", "style"]),
                _createVNode(_component_Column, {
                  style: _ctx.KpiDocumentDesignerKpiListCardDescriptor.iconColumnStyle
                }, {
                  body: _withId((slotProps) => [
                    _createVNode(_component_Button, {
                      icon: "pi pi-trash",
                      class: "p-button-link",
                      onClick: ($event: any) => (_ctx.deleteKpiAssociationConfirm(slotProps.data))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            }, 8, ["value", "filters", "globalFilterFields"])
          ]),
          _createVNode(_component_KpiDocumentDesignerKpiSelectDialog, {
            kpiList: _ctx.kpiList,
            visible: _ctx.addKpiAssociationVisible,
            data: _ctx.data,
            onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addKpiAssociationVisible = false)),
            onKpiSelected: _ctx.onKpiSelected
          }, null, 8, ["kpiList", "visible", "data", "onKpiSelected"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
})